
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { addDays, format } from 'date-fns'
import { useAuth } from '../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { dateToString } from '../../utils/Library'
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Box } from '@mui/material'
import { facilityData } from '../../Store'

const BidHistoryMonitor = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode ? authInfo.facilityCode : facilityData.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId ? authInfo.userId : 'Signage'
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')
    const navigate       = useNavigate()

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ entryDate,   setEntryDate   ] = useState(today)
    const [ recentList,  setRecentList  ] = useState([])
    const [ historyList, setHistoryList ] = useState([])

    
    const [recentData, setRecentData] = useState({
        entryNo    : '',
        senmei     : '',
        gyoshu     : '',
        kgSuryo    : '',
        endTime    : '',
        recentFlag : 0
    })
    const [histroyData, setHistoryData] = useState({
        entryNo : '',
        senmei  : '',
        gyoshu  : '',
        kgSuryo : '',
        endTime : '',
    })
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchDataByBidHistory / Signage
	//-----------------------------------------------
    const { response : searchData_res, post:searchData_post } = usePost()
    const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.Signage',
            'methodName'   : 'searchDataByBidHistoryRecent',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await searchData_post(postData)
    }
    //-----------------------------------------------
    // API - searchDataByBidHistory / Signage
    //-----------------------------------------------
    const { response : searchData_history_res, post:searchData_history_post } = usePost()
    const searchData_history = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.Signage',
            'methodName'   : 'searchDataByBidHistory',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await searchData_history_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        searchData()
        searchData_history()
        
        // 30秒ごとにデータを更新するタイマーを設定
        const interval = setInterval(timer, 10000)
    
        // コンポーネントのアンマウント時にタイマーをクリア
        return () => clearInterval(interval)
        
    },[])
    const timer = () => {
        searchData()
        searchData_history()
    }
	//-----------------------------------------------
    // useEffect - searchDataByBidHistory / Signage
	//-----------------------------------------------
    useEffect(() => {
        setRecentList([])
        if (searchData_res) {
            setRecentData(searchData_res)
            setRecentList(searchData_res.Data)
        }
    }, [searchData_res])
	//-----------------------------------------------
    // useEffect - searchDataByBidHistory / Signage
	//-----------------------------------------------
    useEffect(() => {
        setHistoryList([])
        if (searchData_history_res) {
            setHistoryData(searchData_history_res)
            setHistoryList(searchData_history_res.Data)
        }
    }, [searchData_history_res])

	//===============================================
	// eventHandler
	//===============================================
    const handleClick_header = () => {
        userId == 'Signage' ? navigate('/') : navigate('/signageMenu')
    }
    //===============================================
    // Css
    //===============================================
    const bidHistoryMonitor_table_cell_header = {
        backgroundColor: '#fff', color: '#005243', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em',
        borderBottom:'3px solid #005243', borderTop:'3px solid #005243'
    }
    const bidHistoryMonitor_table_cell_left = {
        padding:'5px', fontSize:'2em', fontWeight:'bold', backgroundColor: '#fff', color: '#005243', borderBottom:'3px solid #005243', borderRight:'3px solid #005243'
    }
    const bidHistoryMonitor_table_cell_right = {
        padding:'5px', fontSize:'2em', fontWeight:'bold', 
        backgroundColor: '#005243', color: '#fff', borderBottom:'3px solid #fff', borderRight:'3px solid #fff'
    }
    //-----------------------------------------------
	// 正規表現でセパレート
    //-----------------------------------------------
	const separate = (num) => {
    	return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	}
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <div className='bidHistoryMonitor signageContens' style={{ height: '100vh',overflow:'hidden' }}>
                <Box display="flex" justifyContent="start">
                    <Box sx={{pt: 0, pr: 0, width:'50%', border:'3px solid #fff', height: '99vh'}}>
                        <div className={recentData.recentFlag ? 'blinking' : 'monitor'}>
                            <div onClick={() => handleClick_header()} style={{paddingTop:'0.5em', paddingBottom:'0.5em'}}>
                                {
                                    recentData.entryNo ?
                                    <>
                                    <div>
                                        <span style={{fontSize:'2em', fontWeight:'bold'}}>{`入札No.《${recentData.entryNo}》`}</span>
                                        <span style={{fontSize:'2em', fontWeight:'bold', marginLeft:'1em'}}>{ recentData.senmei }</span>
                                        <span style={{fontSize:'2em', fontWeight:'bold', marginLeft:'0em'}}>/ { recentData.displayGyoshu }</span>
                                    </div>
                                    <div>
                                        {
                                            recentData.kgKubun ?
                                            <span style={{fontSize:'2em', fontWeight:'bold', marginLeft:'1em'}}>{ recentData.kgSuryo ? recentData.kgSuryo : '---' }Kg</span>
                                            :
                                            <span style={{fontSize:'2em', fontWeight:'bold', marginLeft:'1em'}}>{ recentData.suryo ? recentData.suryo : '---' }箱</span>
                                        }
                                        <span style={{fontSize:'2em', fontWeight:'bold', marginLeft:'1em'}}>{`${recentData.endTime}`}</span>
                                        {
                                            recentData.pageCount > 1 ?
                                            <span style={{fontSize:'2em', fontWeight:'bold', marginLeft:'1em'}}>{`(${recentData.pageNum}/${recentData.pageCount})`}</span>
                                            :
                                            <></>
                                        }
                                    </div>
                                    </>
                                    :
                                    <>
                                    <div>
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#fff'}}>【落札情報】</span>
                                    </div>
                                    <div>
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243'}}>&nbsp;</span>
                                    </div>
                                    </>
                                }
                            </div>
                        </div>
                            <TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'0'}}>
                                <Table stickyHeader sx={{ minWidth: '500px', padding:0 }} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} style={{ width: '20vh', color: '#005243', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em', borderBottom:'3px solid #005243', borderTop:'3px solid #005243', borderLeft:'3px solid #005243' }} align='center'>コード</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} style={{ width: '30vh', color: '#005243', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em', borderBottom:'3px solid #005243', borderTop:'3px solid #005243' }} align='center'>屋号</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} style={{ width: '30vh', color: '#005243', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em', borderBottom:'3px solid #005243', borderTop:'3px solid #005243' }} align="center">入札単価</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} style={{ width: '30vh', color: '#005243', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em', borderBottom:'3px solid #005243', borderTop:'3px solid #005243' }} align="center">落札数量</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} style={{ width: '30vh', color: '#005243', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em', borderBottom:'3px solid #005243', borderTop:'3px solid #005243' }} align="center">備考</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {recentList.map((row, index) => (
                                        <TableRow key = { row.id } >
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} align="right" style={{padding:'5px', fontSize:'2em', fontWeight:'bold', backgroundColor: '#fff', color: '#005243', borderBottom:'3px solid #005243', borderRight:'3px solid #005243', borderLeft:'3px solid #005243'}}>{ row.traderCode }</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} align="left" style={{padding:'5px', fontSize:'2em', fontWeight:'bold', backgroundColor: '#fff', color: '#005243', borderBottom:'3px solid #005243', borderRight:'3px solid #005243'}}>{ row.trader }</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} align="right" style={{padding:'5px', fontSize:'2em', fontWeight:'bold', backgroundColor: '#fff', color: '#005243', borderBottom:'3px solid #005243', borderRight:'3px solid #005243'}}>{ separate(row.tanka) }円</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} align="right" style={{padding:'5px', fontSize:'2em', fontWeight:'bold', backgroundColor: '#fff', color: '#005243', borderBottom:'3px solid #005243', borderRight:'3px solid #005243'}}>{ row.entrySuryo }</TableCell>
                                            <TableCell className={recentData.recentFlag ? 'blinking_header' : 'tableCell_header'} align="right" style={{padding:'5px', fontSize:'2em', fontWeight:'bold', backgroundColor: '#fff', color: '#005243', borderBottom:'3px solid #005243', borderRight:'3px solid #005243'}}>{ row.condition }</TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Box sx={{pt: 0, pr: 0, width:'50%', border:'3px solid #fff', height: '99vh'}}>
                            <div onClick={() => handleClick_header()} style={{backgroundColor:'#fff', paddingTop:'0.5em', paddingBottom:'0.5em'}}>
                                {
                                    histroyData.entryNo ?
                                    <>
                                    <div>
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243'}}>{`入札No.《${histroyData.entryNo}》`}</span>
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243', marginLeft:'1em'}}>{ histroyData.senmei }</span>
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243', marginLeft:'0em'}}>/ { histroyData.displayGyoshu }</span>
                                    </div>
                                    <div>
                                        {
                                            histroyData.kgKubun ?
                                            <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243', marginLeft:'1em'}}>{ histroyData.kgSuryo ? histroyData.kgSuryo : '---' }Kg</span>
                                            :
                                            <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243', marginLeft:'1em'}}>{ histroyData.suryo ? histroyData.suryo : '---' }箱</span>
                                        }
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243', marginLeft:'1em'}}>{`${histroyData.endTime}`}</span>
                                        {
                                            histroyData.pageCount > 1 ?
                                            <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243', marginLeft:'1em'}}>{`(${histroyData.pageNum}/${histroyData.pageCount})`}</span>
                                            :
                                            <></>
                                        }
                                    </div>
                                    </>
                                    :
                                    <>
                                    <div>
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243'}}>【落札情報】</span>
                                    </div>
                                    <div>
                                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243'}}>&nbsp;</span>
                                    </div>
                                    </>
                                }
                            </div>
                            <TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'0'}}>
                                <Table stickyHeader sx={{ minWidth: '500px', padding:0 }} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '20vh', borderLeft:'3px solid #005243' }} align='center'>コード</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '30vh' }} align='center'>屋号</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '30vh' }} align="center">入札単価</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '30vh' }} align="center">落札数量</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '30vh' }} align="center">備考</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {historyList.map((row, index) => (
                                        <TableRow key = { row.id } >
                                            <TableCell sx={ bidHistoryMonitor_table_cell_right } align="right" style={{borderLeft:'3px solid #005243'}}>{ row.traderCode }</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_right } align="left">{ row.trader }</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_right } align="right">{ separate(row.tanka) }円</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_right } align="right">{ row.entrySuryo }</TableCell>
                                            <TableCell sx={ bidHistoryMonitor_table_cell_right } align="right" style={{borderRight:'3px solid #005243'}}>{ row.condition }</TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                    <div>
                </div>
            </div>
        </>
    )
}
export default BidHistoryMonitor
  